import Plyr from 'plyr';

function videoBlock(iframeElement) {
  const iframeEl = iframeElement as HTMLIFrameElement;
  // @ts-ignore
  const { Cookiebot } = window ?? ''; // Is set by the CookieBot

  if (!Cookiebot) return;

  window.addEventListener('CookiebotOnAccept', () => {
    setTimeout(() => {
      new Plyr('#player');
    }, 1000);
  });
}
export default videoBlock;
